var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "feature-tile" }, [
    _c("div", { staticClass: "feature-tile-wrapper" }, [
      _c("a", { attrs: { href: _vm.result.NodeAliasPath } }, [
        _c("div", {
          staticClass: "feature-tile-image",
          style: _vm.thumbnailImageStyle
        }),
        _vm._v(" "),
        _c("div", { staticClass: "feature-tile-info" }, [
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.result.Title) + "\n\t\t\t\t")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "subtext" }, [
            _vm._v(_vm._s(_vm.result.Description))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68557dc7", { render: render, staticRenderFns: staticRenderFns })
  }
}